<script setup>
import {useBaseStore} from "~/stores/base";
import {voteEditPushSwitch, voteQueryPushSwitch} from "~/api/api.vote";
import _ from "lodash";

const BNTOMessage = useNuxtApp().$BNTOMessage
const router = useRouter()
const route = useRoute()

const debounce = _.debounce((params, func) => {
  func(params);
}, 500);

/** emits **/
const emits = defineEmits(["back"])

/** props **/
const props = defineProps({
  swiperSlideIndex: {
    default: 0
  }
})

/** data **/
const notificationSwitch = ref(false)

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)

/** watch **/
watch(() => props.swiperSlideIndex, async () => {
  if (props.swiperSlideIndex === 2) {
    const res = await voteQueryPushSwitch({})
    notificationSwitch.value = res.result.mainPushSwitch === 1
  }
})
watch(notificationSwitch, (newV, oldV) => {
  debounce({}, async () => {
    await voteEditPushSwitch({action: notificationSwitch.value ? 1 : 0})
  })
})

/** methods **/

/** lifecycle **/

</script>

<template>
  <div class="slide-product-polls-notification-settings-mobile" v-if="isMobile">
    <div class="checkbox-vote">
      <el-checkbox v-model="notificationSwitch" size="large"/>
      <span>Get notified when friends vote on items</span>
    </div>
  </div>
  <div class="slide-product-polls-notification-settings-desktop" v-else>
    <div class="checkbox-vote">
      <el-checkbox v-model="notificationSwitch" size="large"/>
      <span>Get notified when friends vote on items</span>
    </div>
  </div>
</template>

<style lang="scss">
.modal-product-polls-notification-settings-mobile {
  .el-checkbox {
    height: fit-content !important;
  }

  .el-checkbox__inner {
    width: 16px !important;
    height: 16px !important;

    &:after {
      left: 5px;
      top: 2px;
    }
  }
}

.modal-product-polls-notification-settings-desktop {
  .el-checkbox {
    height: fit-content !important;
  }

  .el-checkbox__inner {
    width: 16px !important;
    height: 16px !important;

    &:after {
      left: 5px;
      top: 2px;
    }
  }
}
</style>

<style scoped lang="scss">
@import "src/assets/config";

.slide-product-polls-notification-settings-mobile {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 50px;
  overflow-y: auto;

  .checkbox-vote {
    display: flex;
    align-items: center;
    gap: 8px;

    /* Text xs/Regular */
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 150% */
  }
}

.slide-product-polls-notification-settings-desktop {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 50px;
  overflow-y: auto;

  .checkbox-vote {
    display: flex;
    align-items: center;
    gap: 8px;

    /* Text xs/Regular */
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 150% */
  }
}
</style>
